import { useLocation, useParams } from 'react-router-dom';
import { useMemo } from 'react';

interface MapConfig {
  showFindMeButton: boolean;
  showMapListToggle: boolean;
  showClusterMarkers: boolean;
  infoWindowVariant: 'regular' | 'detail';
  mapClassName: string;
  containerClassName: string;
}

export const useMapConfig = (): MapConfig => {
  const { pathname } = useLocation();
  const { id } = useParams();

  return useMemo(() => {
    const isMapCampaign = pathname === '/map-campaign';
    const isDetailPage = pathname.startsWith('/detailPage');

    return {
      showFindMeButton: isMapCampaign,
      showMapListToggle: isMapCampaign,
      showClusterMarkers: isMapCampaign,
      infoWindowVariant: isDetailPage ? 'detail' : 'regular',
      mapClassName: isMapCampaign 
        ? "relative w-full h-[100vh]" 
        : "w-full h-[200px]",
      containerClassName: isMapCampaign
        ? "fixed inset-0 z-0 w-full overflow-hidden"
        : "relative",
    };
  }, [pathname, id]);
};